import React, { useEffect } from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import CampaignReport from "./CampaignReport";
import GroupReport from "./GroupReport";
import { MAKKAH_PERMISSIONS_FULL_NAMES } from "@/utils/constants";
import PermissionGate from "@/CommonElements/PermissionGate";

const CampaignAndGroupReports = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Get current tab from URL, default to 'campaigns'
  const currentTab = searchParams.get("tab") || "campaigns";

  // Set default tab if not present in URL
  useEffect(() => {
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "campaigns" }, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
  };

  const tabItems = [
    {
      key: "campaigns",
      label: t("CAMPAIGNS") || "Campaigns",
      children: <PermissionGate
        permission={
            MAKKAH_PERMISSIONS_FULL_NAMES.view_export_makkah_arrival_campaign_segments_report
        }
      ><CampaignReport /></PermissionGate>,
    },
    {
      key: "groups",
      label: t("GROUPS") || "Groups",
      children: <PermissionGate
        permission={
            MAKKAH_PERMISSIONS_FULL_NAMES.view_export_makkah_group_details_report
        }
      ><GroupReport /></PermissionGate>,
    },
  ];

  return (
    <Stack gap={3}>
      <PageHeader title={t("CAMPAIGN_AND_GROUP_REPORTS")} sticky={false} />
      <Container fluid>
        <Tabs
          activeKey={currentTab}
          items={tabItems}
          onChange={handleTabChange}
          className="mb-3"
        />
      </Container>
    </Stack>
  );
};

export default CampaignAndGroupReports;
